import ColumnNode from '../../../components/ColumnNode';
import Edge from '../../../components/Edges/Edge';
import ForeignEdge from '../../../components/Edges/ForeignEdge';
import TableNode from '../../../components/TableNode';
export { default as TablePropertiesForm } from './TablePropertiesForm';
export { default as ColumnPropertiesForm } from './ColumnPropertiesForm';

export const NODE_VARIANTS = {
  COLUMN: ColumnNode,
  TABLE: TableNode,
};

export const EDGE_VARIANTS = {
  FOREIGN_EDGE: ForeignEdge,
  EDGE: Edge,
};
